import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetUpdatePackagesResData } from "./GetUpdatePackagesResData";

const ENDPOINT = "/device_update/package"

export class GetUpdatePackagesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetUpdatePackagesResData> {
        var res = await this.executeCommand();
        return new GetUpdatePackagesResData(res);
    }

}
